// extracted by mini-css-extract-plugin
export default {"slide":"TechnologiesCarousel_slide__UZli8","trans":"TechnologiesCarousel_trans__BfSxR"};